angular.module('app.controllers.sticky_nav', []).controller('StickyNavController', 
  ['$rootScope', '$scope', '$log', '$timeout', function ($rootScope, $scope, $log, $timeout) {
  'use strict';

  $log.debug('StickyNavController()');

  /* Set the options for the sticky nav based on the page indicated in "menuFor" */
  $scope.setOptions = function (menuFor) {
    $scope.stickySelection = 0;

    if (menuFor === 'residential') {
      $scope.stickyOptions = [
        {label: "Bills & Payments", url: ""},
        {label: "Natural Gas Products", url: ""},
        {label: "Save Money & Energy", url: ""},
        {label: "Special Programs & Assistance", url: ""},
        {label: "Resources", url: "/residential"}
      ];
    }

    else if (menuFor === 'safety') {
      $scope.stickyOptions = [
        {label: "Home & Business Safety", url: ""},
        {label: "Excavators", url: ""},
        {label: "Pipeline Safety", url: ""},
        {label: "Safety Resources", url: ""}
      ];
    }

    else {
      $scope.stickyOptions = [
        {label: "No Options", url: ""}
      ];
    }

    $scope.stickySelectionDisplay = $scope.stickyOptions[$scope.stickySelection].label;
  };

  $scope.setSelection = function (idx) {
    $scope.stickySelectionDisplay = $scope.stickyOptions[idx].label;
    $scope.stickySelection = idx;
  };

  $scope.setupSticky = function() {
    var stickyNavTop;

    $(document).one('scroll', function() {
      stickyNavTop = $('.sticky-menu').offset().top;
    });

    $(window).scroll(function() {
      $('.sticky-menu').toggleClass('sticky',  $(window).scrollTop() > stickyNavTop);
    });
  };

  $(document).ready($scope.setupSticky);

  $timeout(function () {
    $scope.sticky_select = '_default_';
  }, 0);
}]);

